// Modules.
import CommonModules, { Plugins } from '@store'

export default {
  strict: __DEBUG__,
  modules: {
    ...CommonModules
  },
  plugins: Plugins
}
